import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_COMMUNITIES_SOCIAL_SAFEGUARD',
  name: 'Workspace Project Communities Social Safeguard',
  type: 'PROJECT',
  description: '',
  modules: [],
  actions: ['READ', 'CREATE', 'UPDATE', 'DESTROY'],
}

export default scope
